import {makeStyles} from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        minHeight: 'calc(100vh - 54px)',
        marginTop: 54,
        padding: 24,
        boxSizing: 'border-box'
    },
    tableBox: {
        borderRadius: '8px 8px 0 0',
        boxShadow: 'none',
        background: '#fff',
        '&::-webkit-scrollbar': {
            width: '10px',
            height: '10px'
        },
        '&::-webkit-scrollbar-thumb': {
            background: '#6f6f6f',
            borderRadius: '10px',
            backgroundClip: 'padding-box',
            border: '3px solid transparent',
        },
        '&::-webkit-scrollbar-track': {
            background: 'transparent',
            marginTop: 5,
        },
    },
    table: {
        minWidth: 930,
        overflowX: 'auto',
    },
    tableHeadStyle: {
        '& th': {
            height: 50,
            padding: '0 10px',
            fontSize: '1rem',
            fontWeight: 700,
            color: '#10121C',
            borderBottom: '1px solid #BCBCBC'
        }
    },
    tableBodyStyle: {
        '& th, td': {
            padding: '13px 10px',
            fontSize: '1rem',
            fontWeight: 400,
            color: '#10121C',
            borderBottom: '1px solid #BCBCBC'
        },
        '& th': {
            fontWeight: 700,
        },
    },
    tableButton: {
        width: 80,
        height: 30,
        borderRadius: 4,
        background: '#5579F0',
        padding: 0,
        color: '#fff',
        fontSize: '1rem',
        fontWeight: 700,
        '&:hover': {
            background: '#5579F0'
        }
    },
    tableButton2: {
        width: 120,
        height: 30,
        borderRadius: 4,
        background: '#5579F0',
        padding: 0,
        color: '#fff',
        fontSize: '1rem',
        fontWeight: 700,
        '&:hover': {
            background: '#5579F0'
        }
    },
    sortButton: {
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        '& p': {
            fontSize: '1rem',
            fontWeight: 700,
            color: '#10121C',
            marginRight: 4,
            marginLeft: 10,
        }
    },
    paginationBox: {
        '& .MuiToolbar-root': {
            position: 'relative',
        },
        '& .MuiInputBase-root': {
            marginLeft: 0,
            marginRight: 20
        },
        '& .MuiSelect-select': {
            fontSize: '0.75rem',
            color: '#323232',
            paddingRight: 17,
            '&:focus': {
                background: 'transparent'
            }
        },
        '& .MuiTablePagination-caption': {
            fontSize: '0.75rem',
            color: '#10121c',
            fontWeight: 400
        },
        '& .MuiTablePagination-selectLabel': {
            fontSize: '0.75rem',
            color: '#323232',
        },
        '& .MuiTablePagination-selectRoot': {
            '& svg': {
                marginTop: 3
            }
        },
        '& button': {
            padding: 0,
            '&:hover': {
                background: 'transparent'
            },
        }
    },
    displayRow: {
        '& span': {
            fontWeight: '700 !important'
        }
    },
    selectPopover: {
        '& .MuiPaper-root': {
            boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.25)',
            border: '1px solid #bbb',
            boxSizing: 'border-box',
            '& *': {
                fontFamily: 'Pretendard !important',
            },
        },
        '& .MuiMenuItem-root': {
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
            fontSize: '0.875rem',
            color: '#323232',
            padding: '0 12px',
            boxSizing: 'border-box',
            height: 28,
            '&:hover': {
                background: '#eee'
            },
            '&.Mui-selected': {
                background: '#eee'
            },
            '&.Mui-disabled': {
                opacity: 1,
                '& svg': {
                    pointerEvents: 'auto'
                }
            },
        }
    },
    tabBox: {
        '& .MuiTabs-root': {
            minHeight: 40,
        },
        '& .MuiTab-root': {
            minWidth: 100,
        },
        '& .MuiTabs-flexContainer': {
            // width: 248,
            borderBottom: '1px solid #bbbbbb',
            borderRadius: 0,
            overflow: 'hidden'
        },
        '& button': {
            width: 70,
            minHeight: 40,
            height: 40,
            position: 'relative',
            fontSize: '1.063rem',
            fontWeight: 500,
            letterSpacing: '-0.5px',
            color: '#323232',
            boxSizing: 'border-box',
            padding: 0,
        },
        '& button.Mui-selected': {
            fontWeight: 600,
            color: '#5579f0',
            opacity: 1,
            boxSizing: 'border-box',
            background: '#fff',
            borderRadius: 0
        },
        '& .MuiTabs-indicator': {
            height: 3,
            paddingBottom: 0,
            backgroundColor: '#5579f0'
        }
    },
    formControl: {
        '&.MuiFormControl-root ': {
            margin: 0,
        },
        '& .MuiSelect-select': {
            width: 130,
            height: 36,
            padding: '14px 25px 15px 12px !important',
            fontSize: '1.125rem',
            boxSizing: 'border-box',
            color: '#777',
            letterSpacing: '-0.5px',
            display: 'flex',
            alignItems: 'center',
            background: '#fff',
            border: 'solid 1px rgba(50, 50, 50, 0.8)',
            borderRadius: '6px !important',
            '@media all and (max-width: 800px)': {
                width: '100%',
            },
        },
        '& .MuiOutlinedInput-root.Mui-focused .MuiSelect-select': {
            border: '0px solid rgba(117, 0, 250, 0.4)',
            padding: '13px 25px 14px 12px !important',
        },
        '& .MuiOutlinedInput-notchedOutline, .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline, .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
            border: 0,
            borderRadius: 6,
        },
        '& .MuiInput-underline:after, .MuiInput-underline:before': {
            border: 0,
        },
        '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
            border: 0,
        },
        '& .MuiSelect-icon': {
            top: 10,
            right: 6,
        }
    },
    form: {
        width: 130,
        height: 36,
        padding: '14px 25px 15px 12px !important',
        fontSize: '1.125rem',
        boxSizing: 'border-box',
        color: '#777',
        letterSpacing: '-0.5px',
        display: 'flex',
        alignItems: 'center',
        background: '#fff',
        border: 'solid 1px rgba(50, 50, 50, 0.8)',
        borderRadius: '6px !important',
        outline: 'none',
        cursor: 'default',
        '@media all and (max-width: 800px)': {
            width: '100%',
        },
    },
    textBox: {
        '& .MuiBox-root': {
            padding: '10px 0px',
        },
        '& .MuiFormControl-root': {
            width: '100%',

            '& .MuiInputBase-root': {
                borderRadius: 8,
                height: 150,
            }
        }
    },
    textBoxTranslation: {
        '& .MuiFormControl-root': {
            width: '100%',

            '& .MuiInputBase-root': {
                borderRadius: 8,
                height: 60,
            }
        }
    },
    contentBoxTranslation: {
        '& .MuiFormControl-root': {
            width: '100%',

            '& .MuiInputBase-root': {
                borderRadius: 8,
                height: 130,
            }
        }
    },
    translationTitle: {
        marginTop: 33,
        marginBottom: 10,
        '& .MuiTypography-root': {
            fontSize: '0.938rem',
            fontWeight: 'bold',
            letterSpacing: '-0.5px',
            color: '#10121c',
        },
        '& .MuiButtonBase-root': {
            minWidth: 'auto',
            padding: 0,
            '&:hover': {
                background: 'transparent'
            },
        }
    },
    langText: {
        '&.MuiTypography-root': {
            fontSize: '0.938rem',
            fontWeight: 'bold',
            letterSpacing: '-0.5px',
            color: '#10121c',
            marginRight: 10,
        },
    },
    swichStyle: {
        '&.MuiSwitch-root': {
            padding: '10px 10px',
        },
        '& .MuiSwitch-switchBase': {
            color: '#fff',
        },
        '& .MuiSwitch-thumb': {
            width: 14,
            height: 14,
        },
        '& .MuiButtonBase-root': {
            paddingTop: '12px',
            paddingLeft: '12px',
        },
        '& .MuiSwitch-track': {
            borderRadius: 10,
        },
        '& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track': {
            background: '#5579f0',
            opacity: 1
        }
    },
    boxWrap: {
        backgroundColor: '#fff',
        padding: 20,
        borderRadius: 8,
    },
    boxBottomTranslation: {
        backgroundColor: '#fff',
        padding: 20,
        borderRadius: 8,
        marginTop: 20,
        overflowX: 'auto',
        '& .MuiFormControl-root': {
            width: '100%',
        },
        '& div:nth-child(1)': {
            marginTop: 0,
        }
    },
    saveButtonArea: {
        marginTop: 10,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between'
    },
    setButton: {
        '&.MuiButtonBase-root': {
            border: '1px solid #0097FF',
            height: 31,
            borderRadius: 7,
            marginRight: 10,
            '&:hover': {
                background: 'transparent'
            },
            '& .MuiTypography-root': {
                color: '#0097FF',
                fontWeight: 'bold',
                fontSize: '1.25rem'
            }
        }
    },
    setButton1: {
        width: 80,
        height: 30,
        borderRadius: 4,
        background: 'gray',
        padding: 0,
        color: '#fff',
        fontSize: '1rem',
        marginRight: 16,
        fontWeight: 700,
        '&:hover': {
            background: 'gray'
        }
    },
    setButton2: {
        width: 80,
        height: 30,
        borderRadius: 4,
        background: '#7445FF',
        padding: 0,
        color: '#fff',
        fontSize: '1rem',
        fontWeight: 700,
        '&:hover': {
            background: '#7445FF'
        }
    },
}));